import React from "react";
import "./Tabela.css";
import bar from "../../../assets/img/chart_bar_icon.png"

function Tabela({ dadosTabela }) {

    function formatoMoeda(value) {
        if (value) {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
        }

        return 'R$ 0,00';
    }

    function formatoPercentual(value) {
        if (value)
            return `${(parseFloat(value)).toFixed(2).replace('.', ',')}%`;

        return '-';
    }

    function getClasseColunaRegional(valor, meta) {
        if (parseFloat(valor) < parseFloat(meta)) {
            return {
                classCor: 'text-red-c1',
                arrow: <span>&#9662;</span>,
            }
        }

        if (!parseFloat(valor) || !parseFloat(meta)) {
            return 'text-c1';
        }

        return {
            classCor: 'text-green-c1',
            arrow: <span>&#9652;</span>,
        }
    }

    return (
        <div>
            <h2 className="py-3 text-[12px] text-left uppercase font-titulo flex-row"><img src={bar} alt="Ícone" className="icon-img" />Metas e Vendas Total por Departamentos</h2>
            {dadosTabela.length > 0 ? (
                <table style={{ width: '100%' }}>
                    <thead style={{ opacity: '0.9' }}>
                        <tr>
                            <th scope="col" className="coluna-departamento pad-tab text-center text-xs font-medium uppercase tracking-wider">Departamento</th>
                            <th scope="col" className="pad-tab text-center text-xs font-medium uppercase tracking-wider">Meta</th>
                            <th scope="col" className="pad-tab text-center text-xs font-medium uppercase tracking-wider">Real</th>
                            <th scope="col" className="pad-tab text-center text-xs font-medium uppercase tracking-wider">Projeção(R$)</th>
                            <th scope="col" className="pad-tab text-center text-xs font-medium uppercase tracking-wider">Projeção(%)</th>
                        </tr>
                    </thead>
                    <tbody style={{ opacity: '0.7' }}>
                        {Array.isArray(dadosTabela) && dadosTabela.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? 'style-row' : 'bg-white'}>
                                <td className="coluna-departamento pad-tab text-center text-xs font-medium uppercase tracking-wider">{item.departamento}</td>
                                <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{formatoMoeda(item.meta)}</td>
                                <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{formatoMoeda(item.realizado)}</td>
                                <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{formatoMoeda(item.projetado)}</td>
                                <td className={`pad-tab text-center text-xs font-medium uppercase tracking-wider ${getClasseColunaRegional(item.projetado, item.meta).classCor}`}>{getClasseColunaRegional(item.projetado, item.meta).arrow}{formatoPercentual(item.percentualprojetado)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot style={{ opacity: '0.9' }}>
                        <tr>
                            <td className="coluna-departamento pad-tab text-left text-xs font-medium uppercase tracking-wider">Total</td>
                            <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{Array.isArray(dadosTabela) && formatoMoeda(dadosTabela[0].somameta)}</td>
                            <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{Array.isArray(dadosTabela) && formatoMoeda(dadosTabela[0].somarealizado)}</td>
                            <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{Array.isArray(dadosTabela) && formatoMoeda(dadosTabela[0].somaprojetado)}</td>
                            <td className="pad-tab text-center text-xs font-medium uppercase tracking-wider">{Array.isArray(dadosTabela) && formatoPercentual(dadosTabela[0].totalpercentualprojetado)}</td>
                        </tr>
                    </tfoot>
                </table>
            ) : (
                <p className='p-info-tab font-titulo'>Sem dados no momento!</p>
            )}
        </div>
    );
}

export default Tabela